<template>
    <div v-if="!isLoaded">
        <div>
            <div class="row">
                <div class="col-lg-12">
                    Cargando...
                </div>
            </div>
        </div>
    </div>
    <div v-if="isLoaded">
        <form @submit.prevent="handleSubmit">
            <div>
                <div class="row mb-3">
                    <div class="col-lg-12">
                        <label for="project" class="form-label">Proyecto:</label>
                        <input disabled type="text" id="project" class="form-control"
                            :value="`${recordData.client} - ${recordData.identifier} - ${recordData.project}`">
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-8">
                        <label for="activity" class="form-label">Actividad:</label>
                        <select v-model="recordData.activity_id" class="form-control">
                            <option v-for="act in activities" :key="act.activity_id" :value="act.activity_id">
                                {{ act.activity }}
                            </option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label for="eventDate" class="form-label">Fecha:</label>
                        <input type="date" id="eventDate" v-model="recordData.date" class="form-control" required />
                    </div>
                </div>
                <div v-if="showOnSite" class="row mb-3">
                    <div class="col-lg-12 d-flex align-items-center  justify-content-center">
                        <div class="me-2 mt-1">En Planta?</div>
                        <div class="form-check form-switch mb-0 ms-2">
                            <input v-model="recordData.on_site" class="form-check-input form-check-input-warning"
                                type="checkbox" />
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-6">
                        <label for="eventStartTime" class="form-label">Hora de
                            Inicio:</label>
                        <input type="time" id="eventStartTime" v-model="recordData.start_time" class="form-control"
                            required />
                    </div>
                    <div class="col-lg-6">
                        <label for="eventEndTime" class="form-label">Hora de
                            Finalización:</label>
                        <input type="time" id="eventEndTime" v-model="recordData.end_time" class="form-control"
                            required />
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-12">
                        <label for="notes" class="form-label">Notas:</label>
                        <input type="text" id="notes" v-model="recordData.notes" class="form-control" />
                    </div>
                </div>
                <button size="lg" type="submit" class="btn btn-warning w-100 mb-0">Guardar</button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue';

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const props = defineProps({
    selectedData: Object,
});

const recordData = ref({});

const activities = ref([]);

const isNexon = ref(false)
const showOnSite = ref(true)
const isLoaded = ref(false)

const verifyIsNexon = () => {
    if (recordData.value.client_id && recordData.value.client_id == 2) {
        isNexon.value = true
        showOnSite.value = false
    } else {
        showOnSite.value = true
    }
}

const fetchActivities = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/user-activities`, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        activities.value = response.data; // Asigna los datos a variable `time_records`
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const formatTime = (timeString) => {
    const time = new Date(timeString);
    // Convertimos la hora local a la hora en el formato HH:mm
    const hours = time.getUTCHours().toString().padStart(2, '0');  // Usamos getUTCHours para evitar desfases
    const minutes = time.getUTCMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}

const loadRecordEditInfo = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/record-edit-info`, { time_record_id: props.selectedData.time_record_id }, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        const data = response.data[0];

        if (data.is_auth === true) {
            alert('No puedes editar un registro Autorizado')
            window.location.reload()
        }

        recordData.value.date = new Date(data.date).toISOString().split('T')[0];
        recordData.value.total_hours = data.total_hours;
        recordData.value.start_time = formatTime(data.start_time);
        recordData.value.end_time = formatTime(data.end_time);
        recordData.value.is_billable = data.is_billable;
        recordData.value.on_site = data.on_site;
        recordData.value.client_id = data.client_id;
        recordData.value.project_id = data.project_id;
        recordData.value.activity_id = data.activity_id;
        recordData.value.notes = data.notes;
        recordData.value.identifier = data.identifier;
        recordData.value.project = data.project;
        recordData.value.client = data.client;
        recordData.value.is_auth = data.is_auth;
        recordData.value.is_extra_time = data.is_extra_time

        isLoaded.value = true

    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const handleSubmit = async () => {

    const body = {
        time_record_id: props.selectedData.time_record_id,
        start_time: recordData.value.start_time,
        end_time: recordData.value.end_time,
        date: recordData.value.date,
        activity_id: recordData.value.activity_id,
        is_billable: recordData.value.is_billable,
        on_site: recordData.value.on_site,
        notes: recordData.value.notes,
        is_extra_time: recordData.value.is_extra_time,
    }

    // Convertir start_time y end_time a objetos Date
    const startTime = new Date(`1970-01-01T${body.start_time}Z`);
    let endTime = new Date(`1970-01-01T${body.end_time}Z`);

    // Validación para asegurarse de que start_time sea menor que end_time
    if (startTime >= endTime) {
        alert('La hora de inicio debe ser menor que la hora de fin.');
        return; // Detiene la ejecución si la validación falla
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/update-event`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        if (response.status == 200) {
            alert('Evento Actualizado')
            window.location.reload()
        }
    } catch (error) {
        console.error('Error al editar la actividad:', error);
        // Verificar si hay respuesta del servidor
        if (error.response) {
            alert(error.response.data.msg || 'Ocurrió un error al editar el evento.');
        } else {
            alert('Error de conexión con el servidor.');
        }
    }
}


onMounted(async () => {
    await fetchActivities();
    await loadRecordEditInfo();
    verifyIsNexon();
});
</script>